import { HeadingProps, ButtonProps } from '@chakra-ui/react';
import { bucketUrl } from 'utils/files';
import { Button, Heading, Image } from 'components/UI';

type ProductViewProps = {
  thumbnail?: string;
  disabled?: boolean;
  productKey: string | null;
  displayName: string | null;
  name: string | null;
  headingProps?: HeadingProps;
  buttonProps?: ButtonProps;
  updateSelectedProduct: (...args: any) => void;
};

const ProductView = ({
  thumbnail,
  disabled,
  productKey,
  displayName,
  name,
  headingProps = { sx: { mt: 2 } },
  buttonProps,
  updateSelectedProduct,
}: ProductViewProps) => {
  const updateSelectedProductLocal = (newProductKey: string | null) => {
    updateSelectedProduct(newProductKey);
  };

  const renderThumbnail = thumbnail ? (
    <Image
      src={`${bucketUrl}/${thumbnail}`}
      alt={name as string}
      objectFit="cover"
      alignSelf="center"
      h={200}
      w={200}
    />
  ) : null;

  return (
    <Button
      disabled={disabled}
      onClick={() => {
        updateSelectedProductLocal(productKey);
      }}
      sx={{
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        flexDir: 'column',
        p: 4,
        h: !thumbnail ? 260 : 'auto',
        w: !thumbnail ? 230 : 'auto',
        flexWrap: 'wrap',
        ...(buttonProps?.sx ?? {}),
      }}
      variant="unstyled"
    >
      {renderThumbnail}

      <Heading
        as="h6"
        sx={{
          fontWeight: 'medium',
          color: 'gray.600',
          wordBreak: 'break-word',
          whiteSpace: 'initial',
          w: 'full',
          mt: 2,
          ...(headingProps?.sx ?? {}),
        }}
        size="sm"
      >
        {displayName}
      </Heading>
    </Button>
  );
};

export default ProductView;
